export interface HeaderToggleI {
    companyId: number
    companyName: string
    created: string
    createdBy: string
    email: string
    enabled: string
    firstname: string
    id: number
    lastname: string
    remarks: string | null
    usertype: string
}
export function emptyHeaderToggleI() {
    return {
        companyId: 0,
        companyName: "",
        created: "",
        createdBy: "",
        email: "",
        enabled: "",
        firstname: "",
        id: 0,
        lastname: "",
        remarks: null,
        usertype: ""
    }
}